import { render, staticRenderFns } from "./AssetDescription.vue?vue&type=template&id=dc3c0950&scoped=true&"
import script from "./AssetDescription.vue?vue&type=script&lang=js&"
export * from "./AssetDescription.vue?vue&type=script&lang=js&"
import style0 from "./AssetDescription.vue?vue&type=style&index=0&id=dc3c0950&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc3c0950",
  null
  
)

export default component.exports